export const getCurrency = countryCode => {
  let currency;
  switch (countryCode) {
    case 'CA': {
      currency = 'CAD';
      break;
    }
    case 'DE': {
      currency = 'EUR';
      break;
    }
    case 'GB': {
      currency = 'GBP';
      break;
    }
    case 'AU': {
      currency = 'AUD';
      break;
    }
    case 'MX': {
      currency = 'MXN';
      break;
    }
    case 'US':
    default: {
      currency = 'USD';
      break;
    }
  }
  return currency;
};



// WEBPACK FOOTER //
// ./src/utils/currency.js